<template>
  <div>
      <transition v-if="isAnim" name="show-footer">
        <footer v-if="show" class="orange-footer"></footer>
      </transition>
      <footer v-if="!isAnim" class="orange-footer"></footer>
  </div>
</template>

<script>
export default {
  name: 'footer-main',
  props: ['isAnim'],
  data: function() {
    return {
      show: false
    }
  },
  mounted: function() {
    this.show = true;
  },
}
</script>


<style scoped>
  .show-footer-enter-active,
  .show-footer-leave-active {
    transition: transform 0.5s 1s;
    transform: translate(0);
  }
  
  .show-footer-enter,
  .show-footer-leave-to
  {
    transform: translateY(100%);
  }
</style>


// WEBPACK FOOTER //
// FooterOrange.vue?cb546f20